import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const DeleteProjectTypoSquattingAssets = (rmUid, accessToken) => {
  return axios.delete(
    `${apiUrlInternal}/typosquatting_projects/assets/${rmUid}`,
    addAuthToFetchOpts(accessToken, {})
  ).then(res => res.data);
}

export const useDeleteProjectTypoSquattingAssets = (fetcher = DeleteProjectTypoSquattingAssets) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['delete-project-typosquatting'],
    (accessToken, {rmUid}) => fetcher(rmUid, accessToken),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('delete-project-typosquatting');
        queryClient.invalidateQueries('users-me');
      }
    }
  )
}
